import * as React from 'react';
import { Form, Input } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { templateFieldName } from '../../utils/ProjectTemplateUtils';

// The picked template's custom fields, as inputs on a project form. Required and
// optional groups render identically apart from the rule, and the values are read
// back out on submit by getProjectTemplateDetails.
//
// antd v4 Form.Item, so both project forms (create and edit) use this as-is.
const ProjectTemplateDetailFields = ({ projectTemplate }) => (
	<>
		{['requiredFields', 'optionalFields'].map((group) =>
			nullSafeGetOrElse(group, projectTemplate, []).map((field) => (
				<Form.Item
					key={`${group}-${field.key}`}
					label={field.key}
					name={templateFieldName(group, field.key)}
					validateTrigger={['onChange', 'onBlur']}
					rules={
						group === 'requiredFields'
							? [{ required: true, message: 'This field is required.' }]
							: []
					}
				>
					<Input style={{ maxWidth: 640 }} />
				</Form.Item>
			))
		)}
	</>
);

export default ProjectTemplateDetailFields;
